import PropTypes from 'prop-types';
import SiteHistory from './components/SiteHistory';
import ReimbursementDue from './components/ReimbursementDue';
import EnergyUsage from './components/EnergyUsage';
import LandShareUtilisation from './components/LandShareUtilisation'

const LsDno = ({statement}) => {

  const reimbursementDue = 0;

  return (
    <div>
      <SiteHistory siteLiveDate={statement.data.siteLiveDate} liveDaysInQ={statement.data.liveDaysInQ}/>
      <EnergyUsage data={statement.data}/>
      <LandShareUtilisation data={statement.data} /> 

      {/* get clarification from leo */}
      <ReimbursementDue reimbursementDue={reimbursementDue}/>
    </div>
  )
}

export default LsDno;

LsDno.propTypes = {
  statement: PropTypes.object.isRequired,
};